import { TableCell, TableHead, cn } from "@rarible_int/anaconda_ui_components"

type CellProps = React.ComponentProps<typeof TableCell>

export function HeaderCell(props: CellProps) {
  return <TableHead {...props} />
}

export function Cell(props: CellProps) {
  return <TableCell {...props} />
}
